import { COLOR_PAGE_PATH, PageType } from 'constants/pages';

export default function getPageTypeFromSlug(slug: string) {
  if (new RegExp(`^${COLOR_PAGE_PATH}[^/]+$`).test(slug) || `${slug}/` === COLOR_PAGE_PATH) {
    return PageType.Color;
  }

  if (
    new RegExp(`^template(s)?/.*$`).test(slug) &&
    !new RegExp('^templates\\/s\\/.+$').test(slug)
  ) {
    return PageType.Template;
  }

  return PageType.LandingOrHub;
}
